import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn } from "helpers/reactTable";
import { deletedFilters, tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { restoreItem } from "sources/books/routeControlPoints";

export class RouteControlPoints extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams("route-control-points", deletedFilters());
    }

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.routeControlPointsShow(id)}>{value}</Link>,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
            isDeletedColumn(
                (id) =>
                    this.props.modal({
                        name: "confirm",
                        title: "Вы действительно хотите восстановить?",
                        action: () => restoreItem({ id }).then(() => this.props.mergeParams({})),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    }),
                this.props.canEditBooks,
            ),
        ];
    }

    renderCreateButton = () => {
        const { createBtnText, modal, mergeParams, items } = this.props;
        const firstItemId = items && items.length > 0 ? items[0].id : null;
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.routeControlPointsNew,
        };
        return (
            <>
                <Link {...props}>{createBtnText}</Link>
                {firstItemId && (
                    <button
                        className="btn btn-secondary btn-sm ml-2"
                        onClick={() =>
                            modal({
                                name: "importRouteControlPoints",
                                title: "Импорт точек контроля маршрута",
                                windowMod: "wide",
                                firstItemId,
                                onSuccess: () => mergeParams({}),
                            })
                        }
                    >
                        Импортировать
                    </button>
                )}
            </>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(RouteControlPoints, "route-control-points");
